import Vue from 'vue'
import Vuex from 'vuex'
import api from '../apis'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    companyInfo: null, // state 0审核中 1通过 2拒绝
    arcUserInfo: null,  //账号等级(1超管;20管理员;30普通开发者;100无角色)
  },
  mutations: {
    updateUserInfo(state, info) {
      state.userInfo = info || null
    },
    updateCompanyInfo(state, info) {
      state.companyInfo = info || null
    },
    updateArcInfo(state, info) {
      state.arcUserInfo = info || null
    }
  },
  actions: {
    async getUserInfo(context) {
      const userInfo = await api.user.info().catch(e => {
        console.error(e)
      })
      context.commit('updateUserInfo', userInfo)
      const arcUserInfo = await api.user.getArcUserInfo().catch(e => {
        console.error(e)
      })
      context.commit('updateArcInfo', arcUserInfo)
    },
    async getCompanyInfo(context) {
      const companyInfo = await api.company.view().catch(() => {})
      context.commit('updateCompanyInfo', companyInfo)
    }
  }
})
